
(() => {
  const ROOT = '[data-cwl-showcase]';
  const FADE_DURATION = 650;

  function init(root) {
    if (root.dataset.cwlInitialized === 'true') return;

    const layers = [
      ...root.querySelectorAll('.cwl-showcase__background')
    ];

    const gallery = root.querySelector('[data-cwl-gallery]');
    const woodButtons = [
      ...root.querySelectorAll('.cwl-showcase__thumb')
    ];
    const colorButtons = [
      ...root.querySelectorAll('[data-cwl-color]')
    ];

    const prev = root.querySelector('[data-cwl-prev]');
    const next = root.querySelector('[data-cwl-next]');

    if (layers.length !== 2 || !gallery || !woodButtons.length) {
      return;
(() => {
  const ROOT = '[data-cwl-showcase]';
  const FADE_DURATION = 650;

  function init(root) {
    if (root.dataset.cwlInitialized === 'true') return;

    const layers = [
      ...root.querySelectorAll('.cwl-showcase__background')
    ];

    const gallery = root.querySelector('[data-cwl-gallery]');
    const woodButtons = [
      ...root.querySelectorAll('.cwl-showcase__thumb')
    ];
    const colorButtons = [
      ...root.querySelectorAll('[data-cwl-color]')
    ];

    const prev = root.querySelector('[data-cwl-prev]');
    const next = root.querySelector('[data-cwl-next]');

    if (layers.length !== 2 || !gallery || !woodButtons.length) {
      return;
    }

    root.dataset.cwlInitialized = 'true';

    let activeWood = woodButtons.find(
      button => button.classList.contains('is-active')
    ) || woodButtons[0];

    // 1 = original woodgrain, with no color selected.
    let activeStain = 1;

    // Background layer currently displaying the image.
    let visibleLayer = layers.findIndex(
      layer => layer.classList.contains('is-visible')
    );

    if (visibleLayer < 0) visibleLayer = 0;

    let displayedUrl = layers[visibleLayer].getAttribute('src') || '';
    let requestedUrl = displayedUrl;
    let processing = false;

    const cache = new Map();

    function getImageUrl(wood, stain) {
      if (!wood) return '';

      return wood.getAttribute(`data-image-${stain}`) || '';
    }

    function getTargetUrl() {
      return getImageUrl(activeWood, activeStain);
    }

    function preload(url) {
      if (!url) return Promise.resolve(false);

      if (cache.has(url)) {
        return cache.get(url);
      }

      const promise = new Promise(resolve => {
        const image = new Image();

        image.onload = async () => {
          try {
            if (image.decode) {
              await image.decode();
            }
          } catch (error) {
            // Loaded images can still be displayed.
          }

          resolve(true);
        };

        image.onerror = () => resolve(false);
        image.src = url;

        if (image.complete && image.naturalWidth > 0) {
          resolve(true);
        }
      });

      cache.set(url, promise);
      return promise;
    }

    function wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function fadeTo(url) {
      if (!url || url === displayedUrl) return true;

      const loaded = await preload(url);
      if (!loaded) return false;

      // If the visitor has selected another image
      // while loading, skip the obsolete request.
      if (url !== requestedUrl) return false;

      const incomingIndex = 1 - visibleLayer;
      const incoming = layers[incomingIndex];
      const outgoing = layers[visibleLayer];

      // The outgoing image remains fully opaque underneath.
      outgoing.style.zIndex = '0';
      outgoing.style.opacity = '1';

      incoming.style.zIndex = '1';
      incoming.style.transition = 'none';
      incoming.style.opacity = '0';
      incoming.classList.remove('is-visible');

      incoming.src = url;

      try {
        if (incoming.decode) {
          await incoming.decode();
        }
      } catch (error) {
        // Preload already confirmed the image is usable.
      }

      // Commit the invisible state before fading in.
      void incoming.offsetWidth;

      incoming.style.transition =
        `opacity ${FADE_DURATION}ms ease-in-out`;

      incoming.classList.add('is-visible');

      requestAnimationFrame(() => {
        incoming.style.opacity = '1';
      });

      await wait(FADE_DURATION + 60);

      // The new image has completely covered the old one.
      // We can safely hide the old image without dark frames.
      outgoing.classList.remove('is-visible');
      outgoing.style.opacity = '0';
      outgoing.style.zIndex = '0';

      incoming.style.zIndex = '1';

      visibleLayer = incomingIndex;
      displayedUrl = url;

      return true;
    }

    async function processBackground() {
      if (processing) return;

      processing = true;

      try {
        // Always converge to the visitor's latest selection.
        while (requestedUrl && requestedUrl !== displayedUrl) {
          const target = requestedUrl;
          const success = await fadeTo(target);

          if (!success && requestedUrl === target) {
            break;
          }
        }
      } finally {
        processing = false;

        // A newer selection may have arrived while finishing.
        if (requestedUrl &&
            requestedUrl !== displayedUrl &&
            cache.has(requestedUrl)) {
          cache.get(requestedUrl).then(success => {
            if (success && !processing) {
              processBackground();
            }
          });
        }
      }
    }

    function updateBackground() {
      const url = getTargetUrl();

      if (!url) return;

      requestedUrl = url;
      processBackground();
    }

    function updateWoodSelection() {
      woodButtons.forEach(button => {
        const selected = button === activeWood;

        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }

    function updateColorSelection() {
      colorButtons.forEach(button => {
        const selected =
          Number(button.dataset.cwlColor) === activeStain;

        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }

    function selectWood(button) {
      if (activeWood === button) return;

      activeWood = button;

      updateWoodSelection();
      updateBackground();

      // Preload the other colors for the selected woodgrain.
      [1, 2, 3, 4, 5].forEach(stain => {
        const url = getImageUrl(activeWood, stain);
        if (url) preload(url);
      });
    }

    function selectColor(button) {
      const selectedStain = Number(button.dataset.cwlColor);

      if (!selectedStain || selectedStain < 2 || selectedStain > 5) {
        return;
      }

      // Clicking the same color again deselects it.
      if (activeStain === selectedStain) {
        activeStain = 1;
      } else {
        activeStain = selectedStain;
      }

      updateColorSelection();
      updateBackground();
    }

    woodButtons.forEach(button => {
      button.addEventListener('click', () => {
        selectWood(button);
      });
    });

    colorButtons.forEach(button => {
      button.addEventListener('click', () => {
        selectColor(button);
      });
    });

    function updateArrowStates() {
      const maxScroll = Math.max(
        0,
        gallery.scrollWidth - gallery.clientWidth
      );

      const scroll = Math.max(0, gallery.scrollLeft);
      const hasOverflow = maxScroll > 2;

      if (prev) {
        prev.disabled = !hasOverflow || scroll <= 2;
      }

      if (next) {
        next.disabled =
          !hasOverflow || scroll >= maxScroll - 2;
      }
    }

    function scrollGallery(direction) {
      gallery.scrollBy({
        left: direction * gallery.clientWidth * 0.75,
        behavior: 'smooth'
      });
    }

    prev?.addEventListener('click', () => {
      scrollGallery(-1);
    });

    next?.addEventListener('click', () => {
      scrollGallery(1);
    });

    gallery.addEventListener('scroll', updateArrowStates, {
      passive: true
    });

    window.addEventListener('resize', updateArrowStates);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateArrowStates);
      observer.observe(gallery);
    }

    requestAnimationFrame(updateArrowStates);

    window.addEventListener('load', updateArrowStates, {
      once: true
    });

    updateWoodSelection();
    updateColorSelection();

    // Preload only the initial woodgrain variations.
    [1, 2, 3, 4, 5].forEach(stain => {
      const url = getImageUrl(activeWood, stain);
      if (url) preload(url);
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

    }

    root.dataset.cwlInitialized = 'true';

    let activeWood = woodButtons.find(
      button => button.classList.contains('is-active')
    ) || woodButtons[0];

    // 1 = original woodgrain, with no color selected.
    let activeStain = 1;

    // Background layer currently displaying the image.
    let visibleLayer = layers.findIndex(
      layer => layer.classList.contains('is-visible')
    );

    if (visibleLayer < 0) visibleLayer = 0;

    let displayedUrl = layers[visibleLayer].getAttribute('src') || '';
    let requestedUrl = displayedUrl;
    let processing = false;

    const cache = new Map();

    function getImageUrl(wood, stain) {
      if (!wood) return '';

      return wood.getAttribute(`data-image-${stain}`) || '';
    }

    function getTargetUrl() {
      return getImageUrl(activeWood, activeStain);
    }

    function preload(url) {
      if (!url) return Promise.resolve(false);

      if (cache.has(url)) {
        return cache.get(url);
      }

      const promise = new Promise(resolve => {
        const image = new Image();

        image.onload = async () => {
          try {
            if (image.decode) {
              await image.decode();
            }
          } catch (error) {
            // Loaded images can still be displayed.
          }

          resolve(true);
        };

        image.onerror = () => resolve(false);
        image.src = url;

        if (image.complete && image.naturalWidth > 0) {
          resolve(true);
        }
      });

      cache.set(url, promise);
      return promise;
    }

    function wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function fadeTo(url) {
      if (!url || url === displayedUrl) return true;

      const loaded = await preload(url);
      if (!loaded) return false;

      // If the visitor has selected another image
      // while loading, skip the obsolete request.
      if (url !== requestedUrl) return false;

      const incomingIndex = 1 - visibleLayer;
      const incoming = layers[incomingIndex];
      const outgoing = layers[visibleLayer];

      // The outgoing image remains fully opaque underneath.
      outgoing.style.zIndex = '0';
      outgoing.style.opacity = '1';

      incoming.style.zIndex = '1';
      incoming.style.transition = 'none';
      incoming.style.opacity = '0';
      incoming.classList.remove('is-visible');

      incoming.src = url;

      try {
        if (incoming.decode) {
          await incoming.decode();
        }
      } catch (error) {
        // Preload already confirmed the image is usable.
      }

      // Commit the invisible state before fading in.
      void incoming.offsetWidth;

      incoming.style.transition =
        `opacity ${FADE_DURATION}ms ease-in-out`;

      incoming.classList.add('is-visible');

      requestAnimationFrame(() => {
        incoming.style.opacity = '1';
      });

      await wait(FADE_DURATION + 60);

      // The new image has completely covered the old one.
      // We can safely hide the old image without dark frames.
      outgoing.classList.remove('is-visible');
      outgoing.style.opacity = '0';
      outgoing.style.zIndex = '0';

      incoming.style.zIndex = '1';

      visibleLayer = incomingIndex;
      displayedUrl = url;

      return true;
    }

    async function processBackground() {
      if (processing) return;

      processing = true;

      try {
        // Always converge to the visitor's latest selection.
        while (requestedUrl && requestedUrl !== displayedUrl) {
          const target = requestedUrl;
          const success = await fadeTo(target);

          if (!success && requestedUrl === target) {
            break;
          }
        }
      } finally {
        processing = false;

        // A newer selection may have arrived while finishing.
        if (requestedUrl &&
            requestedUrl !== displayedUrl &&
            cache.has(requestedUrl)) {
          cache.get(requestedUrl).then(success => {
            if (success && !processing) {
              processBackground();
            }
          });
        }
      }
    }

    function updateBackground() {
      const url = getTargetUrl();

      if (!url) return;

      requestedUrl = url;
      processBackground();
    }

    function updateWoodSelection() {
      woodButtons.forEach(button => {
        const selected = button === activeWood;

        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }

    function updateColorSelection() {
      colorButtons.forEach(button => {
        const selected =
          Number(button.dataset.cwlColor) === activeStain;

        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
    }

    function selectWood(button) {
      if (activeWood === button) return;

      activeWood = button;

      updateWoodSelection();
      updateBackground();

      // Preload the other colors for the selected woodgrain.
      [1, 2, 3, 4, 5].forEach(stain => {
        const url = getImageUrl(activeWood, stain);
        if (url) preload(url);
      });
    }

    function selectColor(button) {
      const selectedStain = Number(button.dataset.cwlColor);

      if (!selectedStain || selectedStain < 2 || selectedStain > 5) {
        return;
      }

      // Clicking the same color again deselects it.
      if (activeStain === selectedStain) {
        activeStain = 1;
      } else {
        activeStain = selectedStain;
      }

      updateColorSelection();
      updateBackground();
    }

    woodButtons.forEach(button => {
      button.addEventListener('click', () => {
        selectWood(button);
      });
    });

    colorButtons.forEach(button => {
      button.addEventListener('click', () => {
        selectColor(button);
      });
    });

    function updateArrowStates() {
      const maxScroll = Math.max(
        0,
        gallery.scrollWidth - gallery.clientWidth
      );

      const scroll = Math.max(0, gallery.scrollLeft);
      const hasOverflow = maxScroll > 2;

      if (prev) {
        prev.disabled = !hasOverflow || scroll <= 2;
      }

      if (next) {
        next.disabled =
          !hasOverflow || scroll >= maxScroll - 2;
      }
    }

    function scrollGallery(direction) {
      gallery.scrollBy({
        left: direction * gallery.clientWidth * 0.75,
        behavior: 'smooth'
      });
    }

    prev?.addEventListener('click', () => {
      scrollGallery(-1);
    });

    next?.addEventListener('click', () => {
      scrollGallery(1);
    });

    gallery.addEventListener('scroll', updateArrowStates, {
      passive: true
    });

    window.addEventListener('resize', updateArrowStates);

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateArrowStates);
      observer.observe(gallery);
    }

    requestAnimationFrame(updateArrowStates);

    window.addEventListener('load', updateArrowStates, {
      once: true
    });

    updateWoodSelection();
    updateColorSelection();

    // Preload only the initial woodgrain variations.
    [1, 2, 3, 4, 5].forEach(stain => {
      const url = getImageUrl(activeWood, stain);
      if (url) preload(url);
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
